export const SET_MERCHANDISE_COST = "SET_MERCHANDISE_COST";
export const SET_REVENUE = "SET_REVENUE";
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const SET_VARIABLE_COSTS = "SET_VARIABLE_COSTS";
export const SET_FIXED_COSTS = "SET_FIXED_COSTS";

